export const BadFeedbackReasons = [
  'Not helpful',
  'Not accurate',
  'Didn’t work',
  "Didn't answer my question",
  'Too complicated/long',
  'Hard to understand',
  'Missing information',
  'Other',
]
